export default __webpack_public_path__ + "static/media/google-hybrid.de8a69a4.PNG";